export default "__VITE_ASSET__kxlQUooy__"